import {  useState } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import NavClass from './NavClass';
import TabClass from './TabClass';

const TaskContainer = () => {
  const newtaskdata = '';
  const [activeTab, setActiveTab] = useState('1');

  const activeToggle = (tab) => {
    setActiveTab(tab);
  };

  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Tasks' parent='Apps' title='Tasks' />
      <div className='email-wrap bookmark-wrap'>
        <Row>
          <NavClass newtaskdata={newtaskdata} activeToggle={activeToggle} />
          <TabClass activeTab={activeTab} />
        </Row>
      </div>
    </Container>
  );
};

export default TaskContainer;
